import styled, { css } from 'styled-components'

const Step = styled.li`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    gap: ${theme.spacing(4)};
    padding: ${theme.spacing(4)} 0;
    text-align: left;

    &::before {
      transform: translateY(23.8rem);

      ${theme.media('sm')} {
        transform: translateY(0);
      }
    }

    &:not(:last-child) {
      border-bottom: 0.1rem solid ${theme.palette.grey[300]};
    }

    & > div:first-child {
      flex-grow: 1;
    }

    & > div + div {
      order: -1;
      flex-shrink: 0;

      ${theme.media('sm')} {
        order: 1;
      }
    }

    img {
      height: 20rem;
      width: auto;
      max-width: 100%;
      object-fit: cover;

      ${theme.media('sm')} {
        width: 28rem;
      }
    }

    h3,
    p {
      font-weight: 300;
    }

    h3 {
      margin: 0;

      ${theme.maxMedia('sm')} {
        margin-left: ${theme.spacing(5)};
      }
    }

    p {
      font-size: 1.8rem;
      color: ${theme.palette.grey[600]};
    }

    ${theme.media('sm')} {
      flex-direction: row;
      align-items: start;
    }
  `}
`

export default {
  Step,
}
